import { FC } from 'react';
import './FullPageLoader.css';
import { Box } from '@mui/material';

const FullPageLoader: FC = () => {
  return (
    <Box className="loader-overlay">
      <Box className="loader">
        {[...Array(20)].map((_, index) => (
          <Box key={index} className="circle" />
        ))}
      </Box>
    </Box>
  );
};

export default FullPageLoader;
